<!-- Projections:
    title - Used for title of banner. Bold and placed on its own line.
    text - Used for main text of banner. Appears in both unexpanded and expanded banner.
    body - Used for extra text in banner that appears only when expanded. If not provided or empty, banner is unexpandable.
    footer - Used for content to appear at the bottom of the banner, whether expanded or not.
 -->

@if (showBanner) {
    <div
        class="sb-banner"
        [ngClass]="{
            'sb-banner-brand': kind === StatusKind.Default,
            'sb-banner-danger': kind === StatusKind.Danger,
            'sb-banner-warning': kind === StatusKind.Warning
        }"
        [attr.data-sb-qa]="qaTag">
        <div class="d-flex align-items-start w-100">
            <div class="sb-banner-icon-wrapper">
                @switch (kind) {
                    @case (StatusKind.Default) {
                        <lib-icon
                            [icon]="Icon.Common.NewRelease"
                            [size]="IconSize.Small"></lib-icon>
                    }
                    @case (StatusKind.Danger) {
                        <lib-icon
                            [icon]="Icon.Common.Error"
                            [size]="IconSize.Small"></lib-icon>
                    }
                    @case (StatusKind.Warning) {
                        <lib-icon
                            [icon]="Icon.Common.Warning"
                            [size]="IconSize.Small"></lib-icon>
                    }
                }
            </div>
            <div class="sb-banner-content d-flex flex-column">
                @if (mode === BannerMode.Stacked) {
                    <div
                        #content
                        [hidden]="!content.textContent"
                        class="sb-banner-title-wrapper">
                        <h5><ng-content select="[title]"></ng-content></h5>
                    </div>
                }
                <div class="sb-banner-text-wrapper">
                    <p><ng-content select="[text]"></ng-content></p>
                </div>
                @if (mode === BannerMode.Stacked || isMobile) {
                    <ng-container *ngTemplateOutlet="actionsRef"></ng-container>
                }
            </div>
            @if (mode === BannerMode.Inline && !isMobile) {
                <ng-container *ngTemplateOutlet="actionsRef"></ng-container>
            }
            @if (isDismissable) {
                <div class="sb-banner-icon-wrapper">
                    <lib-icon-button
                        [kind]="ButtonKind.NeutralTertiary"
                        [icon]="Icon.Common.Close"
                        [size]="ButtonSize.Small"
                        (clicked)="DismissBanner()"></lib-icon-button>
                </div>
            }
        </div>
    </div>
}

<ng-template #actionsRef>
    <div [ngClass]="{'sb-banner-inline-button-wrapper': mode === BannerMode.Inline, 'sb-banner-button-wrapper': mode === BannerMode.Stacked}">
        <lib-button-group [size]="ButtonGroupSize.Small">
            <ng-content select="[actions]"></ng-content>
        </lib-button-group>
    </div>
</ng-template>
